import React, { useCallback } from 'react';

import EditTimesTooltip from 'modules/fleet/edit-times-tooltip';

import TimeDetailRow from './TimeDetailRow';

const t = {
  pending_appointment: 'Pending appointment',
  sent_to_driver_label: 'sent to driver',
  requested_by_shipper_label: 'requested by shipper',
  appointment_label: 'appointment',
  calculated_label: 'calculated',
};

const getBaseTimeLabel = ({ hasAppointmentTime, isAggregated, store }) => {
  if (isAggregated || store) {
    return t.calculated_label;
  }
  if (hasAppointmentTime) {
    return t.appointment_label;
  }
  return t.requested_by_shipper_label;
};

const TimesRow = ({ onUpdateTimesClick, item, updatingTimes, stop, className }) => {
  const {
    time_from: timeFrom,
    time_to: timeTo,

    adjusted_time_from: adjustedTimeFrom,
    adjusted_time_to: adjustedTimeTo,

    has_appointment_time: hasAppointmentTime,
    appointment_required: appointmentRequired,

    journey_id: journeyId,
    stop_id: stopId,
    status: stopStatus,

    store,

    isAggregated,
  } = stop || {};

  const { status: journeyStatus } = item || {};

  const isAppointmentRequired = appointmentRequired && !hasAppointmentTime;
  const isTimeAdjustedForDriver = timeFrom !== adjustedTimeFrom || timeTo !== adjustedTimeTo;
  const shouldAllowEditTimes =
    store && journeyStatus !== 'PENDING_ASSIGNMENT' && stopStatus === 'PENDING';

  const handleTimesSave = useCallback(
    (timesEdited) => {
      onUpdateTimesClick({ journeyId, stopId, timesEdited });
    },
    [journeyId, stopId, onUpdateTimesClick]
  );

  const baseTimeLabel = getBaseTimeLabel({ hasAppointmentTime, isAggregated, store });

  if (isAppointmentRequired) {
    return (
      <div className={className}>
        <div className="times-row__pending-appointment">{t.pending_appointment}</div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="times-row__times-wrapper">
        <TimeDetailRow timeFrom={timeFrom} timeTo={timeTo} label={baseTimeLabel} />

        {isTimeAdjustedForDriver && (
          <TimeDetailRow
            timeFrom={adjustedTimeFrom}
            timeTo={adjustedTimeTo}
            label={t.sent_to_driver_label}
            showDate={false}
          />
        )}
      </div>
      {shouldAllowEditTimes && (
        <EditTimesTooltip
          enabled={true}
          timeFrom={timeFrom}
          timeTo={timeTo}
          onSave={handleTimesSave}
          disabled={updatingTimes}
        />
      )}
    </div>
  );
};

export default TimesRow;
